var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cardList-wrapper"
  }, [_c("a-row", {
    attrs: {
      gutter: 24
    }
  }, [_vm._l(_vm.aggregate, function (item) {
    return _c("a-col", {
      key: item.id,
      attrs: {
        xs: 12,
        md: 12,
        sm: 12,
        lg: 8
      }
    }, [_c("div", {
      staticClass: "card-item"
    }, [_c("div", {
      staticClass: "card-title"
    }, [_c("a-space", {
      attrs: {
        size: 8
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)) + " ")])], 1), _c("div", {
      staticClass: "all-count"
    }, [_c("count-to", {
      attrs: {
        startVal: 0,
        endVal: 0,
        duration: 1000000
      }
    })], 1)])]);
  }), _vm._l(_vm.panelData, function (item, index) {
    return _c("a-col", {
      key: Number(index + 1) + Number(_vm.timer1),
      attrs: {
        xs: 12,
        md: 12,
        sm: 12,
        lg: 8
      }
    }, [_c("div", {
      staticClass: "card-item"
    }, [_c("div", {
      staticClass: "card-title"
    }, [_c("a-space", {
      attrs: {
        size: 8
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)) + " ")])], 1), _c("div", {
      staticClass: "all-count"
    }, [_c("count-to", {
      attrs: {
        startVal: 0,
        endVal: item.num,
        duration: 2000
      }
    })], 1)])]);
  })], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };